import * as React from 'react'
import { Routes } from '../../../../constants/Routes'
import { Supplier, TaxGroup, IBaseCategory } from '@getgreenline/homi-shared'

interface Props {
  companyId: number
  flattenedCategories?: IBaseCategory[]
  suppliers?: Supplier[]
  taxGroups?: TaxGroup[]
}

export const EmptyProductListing = (props: Props) => {
  const { companyId, flattenedCategories, suppliers, taxGroups } = props

  const showWarning =
    (flattenedCategories && flattenedCategories.length === 0) ||
    (suppliers && suppliers.length === 0) ||
    (taxGroups && taxGroups.length === 0)

  return (
    <section className='border border-light p-4'>
      <header className='mb-4'>
        <i className='fa fa-file-text-o fa-4x' />
        <i className='fa fa-exclamation fa-4x ml-4' />
      </header>

      <main>
        <p className='text-muted'>We could not find products you were searching for.</p>

        {showWarning && (
          <>
            <p className='text-muted'>
              Before adding new products, please complete all of the following steps:
            </p>

            <ul>
              {flattenedCategories && flattenedCategories.length === 0 && (
                <li>
                  <span>
                    <a
                      href={Routes.DASHBOARD_PRODUCTS_CATEGORIES(companyId)}
                      target='_blank'
                      rel='noreferrer'
                    >
                      Add new categories
                    </a>{' '}
                    as it is an essential step to <b>stay compliant</b>. This also makes it easier
                    to search through your products.
                  </span>
                </li>
              )}

              {taxGroups && taxGroups.length === 0 && (
                <li>
                  <span>
                    <a
                      href={Routes.DASHBOARD_SETTINGS_TAXES(companyId)}
                      target='_blank'
                      rel='noreferrer'
                    >
                      Add new tax groups
                    </a>{' '}
                    to generate accurate sales reports.
                  </span>
                </li>
              )}

              {suppliers && suppliers.length === 0 && (
                <li>
                  <a
                    href={Routes.DASHBOARD_PRODUCTS_SUPPLIERS(companyId)}
                    target='_blank'
                    rel='noreferrer'
                  >
                    Add new vendors
                  </a>{' '}
                  to keep track of your product sources.
                </li>
              )}
            </ul>
          </>
        )}
      </main>
    </section>
  )
}
